<template>
	<div class="page">
		<img class="page-bg" src="@/assets/img/background.jpg" alt="">
		<Header />
		<img class="page-slogan" src="@/assets/img/icon_dabiaoti.png" alt="">
		<span class="login-info" v-if="isLogin">
			<font v-text="userInfo"></font>
			<font class="logout-btn hover-dom" @click="handleLogout">退出</font>
			<div class="tips-pop" @click="handleShowNotice(true)">
				<img class="tips-pop-logo hover-dom" src="@/assets/img/icon_zhuyishixiang.png" alt="">
				注意事项
			</div>
		</span>
		<span class="login-info hover-dom" @click="handleLogin" v-else>
			登录
			<div class="tips-pop" @click.stop="handleShowNotice(true)">
				<img class="tips-pop-logo hover-dom" src="@/assets/img/icon_zhuyishixiang.png" alt="">
				注意事项
			</div>
		</span>
		<div class="date-info-box" v-show="periodInfo.registerStartDate">
			<div class="date-info">
				<div class="date-info-node">
					<div class="info-label">抽选时间</div>
					<div
						class="info-content"
						v-text="`${momentFunc(periodInfo.registerStartDate).format('YYYY年M月D日HH:mm')}-${momentFunc(periodInfo.registerEndDate).format('YYYY年M月D日HH:mm')}`"
					></div>
				</div>
				<div class="date-info-node">
					<div class="info-label">确认时间</div>
					<div
						class="info-content"
						v-text="`${momentFunc(periodInfo.payStartDate).format('YYYY年M月D日HH:mm')}-${momentFunc(periodInfo.payEndDate).format('YYYY年M月D日HH:mm')}`"
					></div>
				</div>
			</div>
			<div class="tips-pop">
				<img class="tips-pop-logo hover-dom" src="@/assets/img/icon_zhuyishixiang.png" alt="" @click="handleShowNotice">
				注意事项
			</div>
		</div>
		<template v-if="step === 1">
			<div class="ticket-info-box" v-if="!showAccess">
				<img class="ticket-info-bg" src="@/assets/img/icon_bg.png" alt="">
				<img class="ticket-info-bg-h5" src="@/assets/img/icon_bg_mobile.png" alt="">
				<img
					v-show="(periodInfo.registerStartDate && queryInfoFlg) || !isLogin"
					class="ticket-info-btn hover-dom"
					:src="require((periodTypeFirst  < 2 && registrationStatus === 0) ? '@/assets/img/icon_canyuchouxua.png' : '@/assets/img/icon_wodechouxuan.png')"
					alt=""
					@click="handleTicketAction"
				/>
			</div>
			<img class="ticket-info-bg-tm" src="@/assets/img/logo_bg_TM.png" alt="" v-if="!showAccess">
			<img class="ticket-info-bg-mobile" src="@/assets/img/icon_beijing.png" alt="" v-if="!showAccess">
			<div class="ticket-box" v-if="showAccess">
				<div class="dialog-content-box">
					<div class="dialog-content">
						<div class="back-box hover-dom" @click="handleBack">
							<img src="@/assets/img/icon_fanhui.png" alt="">
							返回
						</div>
						<!-- <div class="dialog-title">注意事项</div> -->
						<div class="dialog-txt" v-html="noticeHtml"></div>
					</div>
				</div>
				<div class="access-checked-box">
					<Checkbox v-model="accessChecked" shape="square" />
					已阅读并同意活动说明及信息收集管理说明
				</div>
				<ButtonVue class="next-btn" :btnConfig="{type: 'green',txt: '下一步>'}" @submit="handleGoGetTicket" />
			</div>
		</template>
		<template v-else-if="step === 2">
			<div class="ticket-box">
				<div class="dialog-content-box">
					<div class="dialog-content">
						<div class="back-box hover-dom" @click="handleBack">
							<img src="@/assets/img/icon_fanhui.png" alt="">
							返回
						</div>
						<div class="dialog-title">抽选实名登记</div>
						<div class="dialog-txt">
							<div class="dialog-tips dialog-tips-top">
								※ <font class="red-txt-bold">实名信息作为线下入场的唯一凭证，一经登记不予修改。</font>
								<br />
								请务必确认您的信息填写无误！
							</div>
							<div class="form-box">
								<div class="form-node">
									<div class="form-label">姓名</div>
									<el-input class="form-action" v-model="name" placeholder="请填写您证件上的姓名"></el-input>
								</div>
								<div class="form-node">
									<div class="form-label">证件类型</div>
									<el-select class="form-action" v-model="idType" placeholder="请选择">
										<el-option
											v-for="item in idTypeList"
											:key="item.value"
											:label="item.label"
											:value="item.value"
										>
										</el-option>
									</el-select>
								</div>
								<div class="form-node">
									<div class="form-label">证件号</div>
									<el-input class="form-action" v-model="idNo" placeholder="请输入您的证件号"></el-input>
									<div class="form-tips">活动当日需凭登记证件入场</div>
								</div>
								<div class="form-node">
									<div class="form-label">联系手机</div>
									<el-input class="form-action" v-model="phone" placeholder="仅支持大陆手机号"></el-input>
									<div class="form-tips">我们将通过您的联系手机发送中选通知</div>
								</div>
							</div>
						</div>
						<ButtonVue class="next-btn" :btnConfig="{type: 'green',txt: '下一步>'}" @submit="handleSetRealname" />
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="step === 3">
			<div class="ticket-box">
				<div class="dialog-content-box">
					<div :class="['dialog-content', !!registrationId ? 'result-box' : '']">
						<div v-if="!registrationId" class="back-box hover-dom" @click="handleBack">
							<img src="@/assets/img/icon_fanhui.png" alt="">
							返回
						</div>
						<div class="dialog-title">选择要抽选的场次</div>
						<div class="dialog-txt">
							<div class="ticket-list">
								<div
									class="ticket-node hover-dom"
									v-for="item in ticketTypeCheckList"
									:key="item.key"
									@click="handleSelectTicket(item)"
								>
									<img :src="item.checked ? item.imgChecked : item.img" alt="">
								</div>
							</div>
							<div class="dialog-tips">
								※ 请注意，一旦中选，中选场次须<font class="red-txt-bold">同时确认</font>，不支持选择性确认。
								<br />
								抽选场次可在<font class="red-txt-bold">{{momentFunc(periodInfo.registerEndDate).format('M月D日HH:mm')}}</font>前进行修改。
							</div>
						</div>
						<ButtonVue class="next-btn" :btnConfig="{type: 'green',txt: '下一步>'}" @submit="handleSetSession" />
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="step === 4">
			<div class="ticket-box">
				<div class="dialog-content-box">
					<div class="dialog-content">
						<div class="back-box hover-dom" @click="handleBack">
							<img src="@/assets/img/icon_fanhui.png" alt="">
							返回
						</div>
						<div class="dialog-title">抽选登记确认</div>
						<div class="dialog-txt">
							<div class="info-confirm-box">
								<div class="info-confirm-title">实名信息</div>
								<div class="info-confirm-title-slogan">REAL-NAME</div>
								<div class="dialog-tips">
									<font class="red-txt-bold">实名信息作为线下入场的唯一凭证，一经登记不予修改。</font>
								</div>
								<div class="form-confirm-box">
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">姓名</div>
											<div class="form-value" v-text="name"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件类型</div>
											<div class="form-value" v-text="idTypeList.find(item=>item.value === idType)?.label"></div>
										</div>
									</div>
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">联系手机</div>
											<div class="form-value" v-text="phone"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件号</div>
											<div class="form-value" v-text="idNo"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="dialog-content">
						<div class="dialog-txt">
							<div class="info-confirm-box">
								<div class="info-confirm-title">抽选场次</div>
								<div class="info-confirm-title-slogan">SESSION</div>
								<div class="dialog-tips">
									<font class="red-txt-bold">{{momentFunc(periodInfo.teamEndDate).format('M月D日HH:mm')}}</font> 前，您可以修改您的抽选场次或与他人进行组队抽选。
								</div>
								<div class="session-info-box">
									<div class="session-info-node">
										<div class="info-label">抽选场次</div>
										<div class="info-content info-content-red" v-if="ticketTypeCheckList[0].checked">
											2024/8/3
										</div>
										<div class="info-content info-content-blue" v-if="ticketTypeCheckList[1].checked">
											2024/8/4
										</div>
									</div>
								</div>
							</div>
						</div>
						<ButtonVue class="next-btn" :btnConfig="{type: 'red',txt: '确认提交>'}" @submit="handleSubmit(false)" />
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="step === 5">
			<div class="ticket-box">
				<div class="dialog-content-box">
					<div class="dialog-content">
						<div class="dialog-title dialog-title-top">成功参与抽选，请等待抽选结果公布!</div>
						<div class="dialog-txt">
							<div class="info-confirm-box">
								<div class="info-confirm-title">实名信息</div>
								<div class="info-confirm-title-slogan">REAL-NAME</div>
								<div class="dialog-tips">
									<font class="red-txt-bold">实名信息作为线下入场的唯一凭证，一经登记不予修改。</font>
								</div>
								<div class="form-confirm-box">
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">姓名</div>
											<div class="form-value" v-text="name"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件类型</div>
											<div class="form-value" v-text="idTypeList.find(item=>item.value === idType)?.label"></div>
										</div>
									</div>
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">联系手机</div>
											<div class="form-value" v-text="phone"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件号</div>
											<div class="form-value" v-text="idNo"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="dialog-content">
						<div class="dialog-txt">
							<div class="info-confirm-box">
								<div class="info-confirm-title">抽选场次</div>
								<div class="info-confirm-title-slogan">SESSION</div>
								<div class="dialog-tips">
									<font class="red-txt-bold">{{momentFunc(periodInfo.teamEndDate).format('M月D日HH:mm')}}</font> 前，您可以修改您的抽选场次或与他人进行组队抽选。
								</div>
								<div class="session-info-box">
									<div class="session-info-node">
										<div class="info-label">抽选场次</div>
										<div class="info-content info-content-red" v-if="ticketTypeCheckList[0].checked">
											2024/8/3
										</div>
										<div class="info-content info-content-blue" v-if="ticketTypeCheckList[1].checked">
											2024/8/4
										</div>
									</div>
									<div class="session-info-node" v-if="Number(teamInfo?.team_status) !== 1">
										<div class="info-label">同行者</div>
										<div class="info-content" v-text="`${teamInfo?.team_member_name || ''}/${teamInfo?.team_member || ''}`">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="periodTypes.includes(3) && Number(teamInfo?.team_status) !== 1" class="dialog-tips dialog-tips-top margin-border">
							如需修改场次，请退出队伍后再进行修改。
						</div>
						<div class="btn-group-box">
							<ButtonVue v-if="periodTypes.includes(1) && Number(teamInfo?.team_status) === 1" class="btn-node" :btnConfig="{type: 'green',txt: '修改场次>'}" @submit="handleChangeSession" />
							<ButtonVue v-if="periodTypes.includes(3) && Number(teamInfo?.team_status) === 1" class="btn-node" :btnConfig="{type: 'red',txt: '邀请亲友>'}" @submit="handleInvite" />
							<ButtonVue v-if="periodTypes.includes(3) && Number(teamInfo?.team_status) === 1" class="btn-node" :btnConfig="{type: 'blue',txt: '加入队伍>'}" @submit="handleTeamAction" />
							<ButtonVue v-if="periodTypes.includes(3) && Number(teamInfo?.team_status) === 2" class="btn-node" :btnConfig="{type: 'green',txt: '解散队伍>'}" @submit="handleQuitTeam" />
							<ButtonVue v-if="periodTypes.includes(3) && Number(teamInfo?.team_status) === 3" class="btn-node" :btnConfig="{type: 'green',txt: '退出队伍>'}" @submit="handleQuitTeam" />
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="step === 6">
			<div class="ticket-box">
				<div class="dialog-content-box">
					<div class="dialog-content result-box">
						<div class="dialog-txt">
							<div class="info-confirm-box">
								<div class="info-confirm-title">实名信息</div>
								<div class="dialog-tips dialog-tips-top">
									<font class="red-txt-bold">实名信息作为线下入场的唯一凭证，一经登记不予修改。</font>
								</div>
								<div class="form-confirm-box">
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">姓名</div>
											<div class="form-value" v-text="registrationInfo.registerName"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件类型</div>
											<div class="form-value" v-text="idTypeList.find(item=>item.value === registrationInfo.registerIdType)?.label"></div>
										</div>
									</div>
									<div class="form-confirm-node">
										<div class="form-confirm-node-left">
											<div class="form-label">联系手机</div>
											<div class="form-value" v-text="registrationInfo.registerPhone"></div>
										</div>
										<div class="form-confirm-node-right">
											<div class="form-label">证件号</div>
											<div class="form-value" v-text="registrationInfo.registerIdNo"></div>
										</div>
									</div>
								</div>
							</div>
							<div class="info-confirm-box">
								<div class="info-confirm-title">场次抽选结果</div>
								<div class="dialog-tips dialog-tips-top">
									若您暂未中选，确认期结束后，我们将会从剩余参与抽选但未中选的用户中
									<br />
									进行<font class="red-txt-bold">补抽</font>，完全结束售票后官网会另行通知。
									<br />
									上一轮确认截止时间为2024/7/2 14:00，未确认订单将无法在本轮确认。
									<br />
									<a href="https://qu.sdo.com/product-detail/1810970190481076224?merchantId=1" target="_blank" rel="noopener noreferrer">
										已确认用户可点此前往购买专属周边。
									</a>
								</div>
								<div class="ticket-list">
									<div
										class="ticket-node hover-dom"
										v-for="item in ticketTypeCheckList.filter(data=> (ticketInfos || []).map(ticketNode=>ticketNode.type).includes(data.key))"
										:key="item.key"
									>
										<img :src="parseStatusImg(item.key)" alt="">
									</div>
								</div>
								<div class="dialog-tips" v-if="payResult === 1">
									<font class="red-txt-bold">活动当日凭登记证件入场！期待您的到来！</font>
								</div>
							</div>
							<div class="btn-group-box" v-if="(ticketInfos || []).find(item => item.ticketResult === 1)">
								<!-- <ButtonVue
									v-if="periodTypeFirst >= 5 && !periodTypes.includes(7) && !periodTypes.includes(8) && payResult === 0"
									:btnConfig="{type: 'gray',txt: `${momentFunc(periodInfo.payStartDate).format('M月D日HH:mm')} 开始确认`,size: 'max'}"
								/> -->
								<ButtonVue
									v-if="periodTypeFirst >= 5 && !periodTypes.includes(7) && !periodTypes.includes(8) && payResult === 0"
									:btnConfig="{type: 'gray',txt: '等待确认开启',size: 'max'}"
								/>
								<ButtonVue
									v-else-if="periodTypes.includes(7) && payResult === 0"
									:btnConfig="{type: 'green',txt: '立即确认>'}"
									@submit="handleGoPay"
								/>
								<ButtonVue v-else-if="payResult === 3" :btnConfig="{type: 'gray',txt: '已超出上一轮确认期，无法确认', size: 'super'}" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<PopupVue
			:popupConfig="popupConfig"
			@cancel="handlePopupClose"
		>
			<div v-if="popupConfig.popupSlot === 1" class="invite-info-box">
				<div class="invite-code" v-text="`邀请码：${inviteCode}`"></div>
				<div class="copy-btn hover-dom" :data-clipboard-text="inviteCode" @click="handleCopyInviteCode">复制</div>
				<div class="invite-tips">
					组队开放期间，受邀亲友只需填写您的邀请码，
					<!-- <br /> -->
					即可组队参与抽选！
					<br />
					<br />
					<font class="red-txt-bold">每队上限2人</font>
				</div>
			</div>
			<div v-if="popupConfig.popupSlot === 2" class="team-info-box">
				<div class="info-title">请填写邀请码</div>
				<el-input class="form-action" v-model="teamInviteCode" placeholder="请输入邀请码"></el-input>
				<ButtonVue class="submit-btn" :btnConfig="{type: 'green',txt: '加入队伍>'}" @submit="handleAddTeam" />
			</div>
			<div v-if="popupConfig.popupSlot === 3" class="team-info-box">
				<div class="info-title">确定要{{ teamInfo.team_status === 2 ? '解散' : '退出' }}队伍吗？</div>
				<ButtonVue class="submit-btn" :btnConfig="{type: 'green',txt: '确定退队>'}" @submit="handleQuitTeamSubmit" />
			</div>
			<div v-if="popupConfig.popupSlot === 4" class="team-info-box">
				<div class="info-title invite-team-info">
					您正在加入<strong>{{inviteTeamInfo.teamLeader}}</strong>的队伍
					<br />
					<div class="ticket-date-box">
						抽选场次
						<strong
							class="ticket-date red-txt"
							v-for="(item, index) in (inviteTeamInfo.ticketList || [])"
							:key="index"
							v-text="momentFunc(item).format('YYYY年M月D日')"
						></strong>
					</div>
				</div>
				<ButtonVue class="submit-btn" :btnConfig="{type: 'green',txt: '确定入队>'}" @submit="handleAddTeamConfirm" />
			</div>
			<div v-if="popupConfig.popupSlot === 5" class="team-info-box">
				<div class="info-title">
					入场人脸验证时会以登记抽选时录入的实名信息为准，
					<!-- <br /> -->
					<font class="red-txt-bold">如信息不一致将无法入场，一旦登记将无法修改，</font>
					<!-- <br /> -->
					请您再次确认！！！</div>
				<ButtonVue class="submit-btn" :btnConfig="{type: 'red',txt: '确定提交>'}" @submit="handleSubmit(true)" />
			</div>
			<div v-if="popupConfig.popupSlot === 6" class="team-info-box">
				<div class="info-title">
					{{ apiResultMsg }}
				</div>
				<ButtonVue class="submit-btn" :btnConfig="{type: 'green',txt: '返回修改>'}" @submit="handleBackToRealName" />
			</div>
		</PopupVue>
		<CaptchaComponent
			:show="captchaShow"
			:captchaType="captchaType"
			:captchaParams="captchaParams"
			@submit="handleGoPay"
			@cancel="handleCloseCaptcha"
		/>
	</div>
</template>

<script>
import {
	storageEventEmit,
	getUrlKey,
} from '@/lib/util';
import Logs from '@/lib/logs';

import {
	periodInfo,
	checkQualification,
	myRegistration,
	ticketConfig,
	registration,
	inviteCode,
	addTeam,
	quitTeam,
	pay,
	teamInfo,
} from '@/api/common';

import { Checkbox, Toast } from 'vant';

import Clipboard from 'clipboard';
import moment from 'moment';

import Header from '../components/Header.vue';
import PopupVue from '../components/Popup.vue';
import ButtonVue from '../components/Button.vue';
import CaptchaComponent from '../components/CaptchaComponent.vue';

import ticketImg1 from '../assets/img/8_3.png';
import ticketCheckedImg1 from '../assets/img/8_3-1.png';
import ticketImg2 from '../assets/img/8_4.png';
import ticketCheckedImg2 from '../assets/img/8_4-1.png';
import waitImg1 from '../assets/img/wait_1.png';
import waitImg2 from '../assets/img/wait_2.png';
import successImg1 from '../assets/img/success_1.png';
import successImg2 from '../assets/img/success_2.png';
import failImg1 from '../assets/img/fail_1.png';
import failImg2 from '../assets/img/fail_2.png';
import paySuccessImg1 from '../assets/img/paySuccess_1.png';
import paySuccessImg2 from '../assets/img/paySuccess_2.png';
import refundImg1 from '../assets/img/refund_1.png';
import refundImg2 from '../assets/img/refund_2.png';

export default {
	name: 'Activity',
	components: {
		Checkbox,
		Header,
		PopupVue,
		ButtonVue,
		CaptchaComponent,
	},
	data() {
		return {
			pageId: 'ff14-fanfest',
			pageName: 'ff14-fanfest',
			isLogin: false,
			userName: '',
			registrationId: '',
			registrationStatus: 0,
			registrationInfo: {},
			queryInfoFlg: false,
			ticketInfos: [],
			teamInfo: '',
			payResult: 0,
			showAccess: false,
			popupConfig: {},
			accessChecked: false,
			step: 1,
			idTypeList: [
				{
					label: '身份证',
					value: 1,
				},
				{
					label: '港澳居民来往大陆通行证',
					value: 2,
				},
				{
					label: '台湾居民来往通行证',
					value: 3,
				},
				{
					label: '护照',
					value: 4,
				},
			],
			name: '',
			idType: 1,
			idNo: '',
			phone: '',
			ticketTypeCheckList: [
				{
					key: 1,
					img: ticketImg1,
					checked: false,
					imgChecked: ticketCheckedImg1,
					waitImg: waitImg1,
					successImg: successImg1,
					failImg: failImg1,
					paySuccessImg: paySuccessImg1,
					refundImg: refundImg1,
				},
				{
					key: 2,
					img: ticketImg2,
					checked: false,
					imgChecked: ticketCheckedImg2,
					waitImg: waitImg2,
					successImg: successImg2,
					failImg: failImg2,
					paySuccessImg: paySuccessImg2,
					refundImg: refundImg2,
				},
			],
			periodTypes: [],
			periodInfo: {},
			popupSlot: 0,
			inviteCode: '',
			teamInviteCode: '',
			captchaShow: false,
			captchaType: 0, // 验证码类型：1：普通图验，4：极验
			captchaParams: {},
			inviteTeamInfo: {},
			apiResultMsg: '',
		};
	},
	created() {
		/* web日志打点 */
		const logs = {
			web_pageid: this.pageId,
			web_page_name: this.pageName,
			web_buttonid: 'load',
			web_button_name: 'page-load',
		};
		Logs.imgLog_Button(logs);

		this.init();
	},
	mounted() {
	},
	methods: {
		init() {
			this.periodInfoFunc();
			if (localStorage.getItem('Authorization')) {
				this.isLogin = true;
				this.userName = localStorage.getItem('displayAccount');

				this.myRegistrationFunc(() => {
					const result = getUrlKey('result');

					this.setStep(Number(result) === 1 ? 6 : 1);
				});
			}
		},
		setStep(nextStep) {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'step-load',
				web_button_name: 'step-load',
				web_ext_json: JSON.stringify({
					step: nextStep,
				}),
			};
			Logs.imgLog_Button(logs);

			if (nextStep) {
				this.step = nextStep;
			}
		},
		periodInfoFunc() {
			const params = {
			};

			periodInfo(params).then(res => {
				this.periodTypes = res.periodTypes || [];
				this.periodInfo = res.periodInfo || {};
			}).catch(() => {});
		},
		checkQualificationFunc(callback) {
			const params = {
			};

			checkQualification(params).then(res => {
				if (callback) {
					callback(res);
				}
			}).catch(() => {});
		},
		myRegistrationFunc(callback) {
			const params = {
			};

			myRegistration(params).then(res => {
				this.registrationId = res?.registrationId;
				this.registrationStatus = res?.registrationStatus;
				this.registrationInfo = res?.registrationInfo || {};
				this.ticketInfos = res?.ticketInfos || [];
				this.teamInfo = res?.teamInfo;
				this.payResult = res?.payResult || 0;
				this.queryInfoFlg = true;

				this.$nextTick(() => {
					this.ticketTypeCheckList[0].checked = !!this.ticketInfos.find(item => item.type === 1);
					this.ticketTypeCheckList[1].checked = !!this.ticketInfos.find(item => item.type === 2);

					this.name = this.registrationInfo?.registerName || '';
					this.idNo = this.registrationInfo?.registerIdNo || '';
					this.idType = this.registrationInfo?.registerIdType || 1;
					this.phone = this.registrationInfo?.registerPhone || '';

					if (callback) {
						callback(res);
					}
				});
			}).catch(() => {});
		},
		ticketConfigFunc() {
			const params = {
			};

			ticketConfig(params).then(res => {
				console.log(res);
			}).catch(() => {});
		},
		registrationFunc() {
			const params = {
				name: this.name.trim(),
				idType: this.idType,
				idNo: this.idNo.trim(),
				phone: this.phone.trim(),
				firstTicket: this.ticketTypeCheckList[0].checked ? 1 : 0,
				secondTicket: this.ticketTypeCheckList[1].checked ? 1 : 0,
			};

			if (this.registrationId) {
				params.registrationId = this.registrationId;
			}

			registration(params).then((res) => {
				if (res.resultCode === 0) {
					this.setStep(5);
					this.myRegistrationFunc();
				} else if ([-102020, -102022, -102025, -102026].includes(res.resultCode)) {
					this.popupConfig = {
						showPopup: true,
						slot: true,
						popupSlot: 6,
						width: '438px',
					};
					this.apiResultMsg = res.resultMessage;
				} else {
					storageEventEmit('show-toast', res.resultMessage);
				}
			}).catch();
		},
		inviteCodeFunc(callback) {
			const params = {
			};

			inviteCode(params).then(res => {
				if (callback) {
					callback(res);
				}
			}).catch(() => {});
		},
		addTeamFunc(callback) {
			const params = {
				inviteCode: this.teamInviteCode,
			};

			addTeam(params).then(res => {
				if (callback) {
					callback(res);
				}
			}).catch(() => {});
		},
		quitTeamFunc(callback) {
			const params = {
			};

			quitTeam(params).then(res => {
				if (callback) {
					callback(res);
				}
			}).catch(() => {});
		},
		payFunc(captchaInfo) {
			this.captchaShow = false;

			const params = {
			};

			if (Object.keys(captchaInfo || {}).length) {
				params.captchaInfo = JSON.stringify(captchaInfo);
			}

			pay(params).then(res => {
				if (res.captchaInfo) {
					this.captchaShow = true;
					this.captchaType = res?.captchaInfo.captchaType;
					this.captchaParams = res?.captchaInfo.captchaParams;
				} else {
					window.location.href = res.cashUrl;
				}
			}).catch(() => {});
		},
		teamInfoFunc() {
			const params = {
				inviteCode: this.teamInviteCode,
			};

			teamInfo(params).then(res => {
				this.inviteTeamInfo = {
					teamLeader: res?.teamLeader || '',
					ticketList: res?.ticketList || [],
				};

				this.$nextTick(() => {
					this.popupConfig = {
						showPopup: true,
						slot: true,
						popupSlot: 4,
						width: '438px',
					};
				});
			}).catch(() => {});
		},
		handleLogin() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'login',
				web_button_name: 'login',
			};
			Logs.imgLog_Button(logs);

			storageEventEmit('user-login');
		},
		handleLogout() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'logout',
				web_button_name: 'logout',
			};
			Logs.imgLog_Button(logs);

			localStorage.clear();

			window.location.href = `https://cas.sdo.com/cas/logout?url=${encodeURIComponent(window.location.href)}`;
		},
		handleShowNotice(isMobile) {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'show-notice',
				web_button_name: 'show-notice',
			};
			Logs.imgLog_Button(logs);

			if (isMobile) {
				this.popupConfig = {
					showPopup: true,
					popupTitle: '注意事项',
					popupContent: this.noticeHtml,
					width: '80vw',
				};
			} else {
				this.popupConfig = {
					showPopup: true,
					popupTitle: '注意事项',
					popupContent: this.noticeHtml,
				};
			}
		},
		handleTicketAction() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'go-session',
				web_button_name: 'go-session',
				web_ext_json: JSON.stringify({
					is_my_session: !(this.periodTypeFirst < 2 && this.registrationStatus === 0),
				}),
			};
			Logs.imgLog_Button(logs);

			if (!this.isLogin) {
				this.handleLogin();

				return;
			}

			const firstDate = this.periodTypes?.[0] || -1;

			if (this.periodTypes.includes(0)) {
				// Toast('活动还没开始哦！');
				storageEventEmit('show-toast', '活动还没开始哦！');
				return;
			}

			if (this.registrationStatus === 0) {
				if (firstDate >= 2) {
					// Toast('抱歉，没有查到您的登记记录哦');
					storageEventEmit('show-toast', '抱歉，没有查到您的登记记录哦');
					return;
				}

				this.showAccess = true;
			} else {
				this.setStep(firstDate < 5 ? 5 : 6);
			}
		},
		handleBack() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'back-btn',
				web_button_name: 'back-btn',
				web_ext_json: JSON.stringify({
					back_step: this.step === 1 ? 1 : this.step - 1,
				}),
			};
			Logs.imgLog_Button(logs);

			this.showAccess = false;

			this.setStep(this.step === 1 ? 1 : this.step - 1);
		},
		handleGoGetTicket() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'access-next',
				web_button_name: 'access-next',
			};
			Logs.imgLog_Button(logs);

			if (!this.accessChecked) {
				// Toast('您需同意活动说明及信息收集管理说明，才可参与抽选');
				storageEventEmit('show-toast', '您需同意活动说明及信息收集管理说明，才可参与抽选');

				return;
			}

			this.checkQualificationFunc((checkRes) => {
				const qualification = checkRes?.qualification || 0;
				if (qualification) {
					this.setStep(2);
				} else {
					// Toast('非常抱歉，暂不满足抽选资格');
					storageEventEmit('show-toast', '非常抱歉，暂不满足抽选资格');
				}
			});
		},
		handleSetRealname() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'set-realname',
				web_button_name: 'set-realname',
			};
			Logs.imgLog_Button(logs);

			let checked = true;
			let tips = '';
			if (!this.name) {
				tips = '请输入姓名';

				checked = false;
			} else if (!this.idNo) {
				tips = '请输入证件号';

				checked = false;
			} else if (Number(this.idType) === 1 && !(/^\d{6}(19|2\d)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)?$/.test(this.idNo))) {
				tips = '请输入正确的身份证号码';

				checked = false;
			} else if (!(/^1\d{10}$/.test(this.phone))) {
				tips = '请输入正确的手机号码';

				checked = false;
			}

			if (!checked) {
				// Toast(tips);
				storageEventEmit('show-toast', tips);

				return;
			}

			this.setStep(3);
		},
		handleSetSession() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'set-session',
				web_button_name: 'set-session',
			};
			Logs.imgLog_Button(logs);

			if (!this.ticketTypeCheckList.find(item => item.checked)) {
				// Toast('请至少选择一个场次');
				storageEventEmit('show-toast', '请至少选择一个场次');

				return;
			}

			this.setStep(4);
		},
		handleSubmit(isSubmit) {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'ticket-submit',
				web_button_name: 'ticket-submit',
				web_ext_json: JSON.stringify({
					is_submit: isSubmit,
				}),
			};
			Logs.imgLog_Button(logs);

			if (isSubmit || this.registrationId) {
				this.popupConfig = {
					showPopup: false,
					slot: true,
					popupSlot: 5,
					width: '550px',
				};
				this.registrationFunc();
			} else {
				this.popupConfig = {
					showPopup: true,
					slot: true,
					popupSlot: 5,
					width: '550px',
				};
			}
		},
		handleBackToRealName() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'back-realname',
				web_button_name: 'back-realname',
			};
			Logs.imgLog_Button(logs);

			this.ticketTypeCheckList = [].concat(this.ticketTypeCheckList.map(item => ({
				...item,
				checked: false,
			})));
			this.popupConfig = {
				showPopup: false,
				slot: true,
				popupSlot: 6,
				width: '438px',
			};
			this.setStep(2);
		},
		handleChangeSession() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'session-change',
				web_button_name: 'session-change',
			};
			Logs.imgLog_Button(logs);

			this.setStep(3);
		},
		handleInvite() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'show-invite',
				web_button_name: 'show-invite',
			};
			Logs.imgLog_Button(logs);

			this.inviteCodeFunc((res) => {
				this.inviteCode = res.inviteCode || '';

				this.popupConfig = {
					showPopup: true,
					slot: true,
					popupSlot: 1,
					width: '438px',
				};
			});
		},
		handleCopyInviteCode() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'code-copy',
				web_button_name: 'code-copy',
			};
			Logs.imgLog_Button(logs);

			const clipboard = new Clipboard('.copy-btn');
			clipboard.on('success', () => {
				Toast('已复制至粘贴板');
				clipboard.destroy();
			});
			clipboard.on('error', e => {
				Toast('该浏览器不支持自动复制!', 'warning', e);
				clipboard.destroy();
			});
		},
		handleTeamAction() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'show-go-team',
				web_button_name: 'show-go-team',
			};
			Logs.imgLog_Button(logs);

			this.popupConfig = {
				showPopup: true,
				slot: true,
				popupSlot: 2,
				width: '438px',
			};
		},
		handleAddTeam() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'show-addteam',
				web_button_name: 'show-addteam',
			};
			Logs.imgLog_Button(logs);

			if (!this.teamInviteCode) {
				// Toast('请输入邀请码');
				storageEventEmit('show-toast', '请输入邀请码');

				return;
			}

			this.teamInfoFunc();
		},
		handleAddTeamConfirm() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'addteam_submit',
				web_button_name: 'addteam_submit',
			};
			Logs.imgLog_Button(logs);

			this.addTeamFunc(() => {
				this.popupConfig = {
					showPopup: false,
				};
				// Toast('组队成功');
				storageEventEmit('show-toast', '组队成功');
				this.myRegistrationFunc();
			});
		},
		handleQuitTeam() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'show-quit-team',
				web_button_name: 'show-quit-team',
				web_ext_json: JSON.stringify({
					is_team_owner: this.teamInfo.team_status === 2,
				}),
			};
			Logs.imgLog_Button(logs);

			this.popupConfig = {
				showPopup: true,
				slot: true,
				popupSlot: 3,
				width: '438px',
			};
		},
		handleQuitTeamSubmit() {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'quit-team-submit',
				web_button_name: 'quit-team-submit',
				web_ext_json: JSON.stringify({
					is_team_owner: this.teamInfo.team_status === 2,
				}),
			};
			Logs.imgLog_Button(logs);

			this.quitTeamFunc(() => {
				this.popupConfig = {
					showPopup: false,
				};
				// Toast('退出组队成功');
				storageEventEmit('show-toast', '退出组队成功');
				this.myRegistrationFunc();
			});
		},
		handleGoPay(captchaInfo) {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'go-pay',
				web_button_name: 'go-pay',
			};
			Logs.imgLog_Button(logs);

			this.payFunc(captchaInfo);
		},
		handleCloseCaptcha() {
			this.captchaShow = false;
			this.captchaInfo = {};
		},
		handleSelectTicket(item) {
			/* web日志打点 */
			const logs = {
				web_pageid: this.pageId,
				web_page_name: this.pageName,
				web_buttonid: 'ticket-select',
				web_button_name: 'ticket-select',
				web_ext_json: JSON.stringify({
					ticket_select: item.key,
				}),
			};
			Logs.imgLog_Button(logs);

			this.ticketTypeCheckList.find(obj => obj.key === item.key).checked = !item.checked;

			this.ticketTypeCheckList = [].concat(this.ticketTypeCheckList);
		},
		handlePopupClose() {
			this.teamInviteCode = '';
		},
	},
	computed: {
		userInfo() {
			return `欢迎你，${this.userName}，`;
		},
		parseStatusImg() {
			return (type) => {
				let img = null;
				const ticketData = this.ticketInfos.find(item => item.type === type) || {};
				const ticketConfigData = this.ticketTypeCheckList.find(item => item.key === type) || {};

				switch (ticketData.ticketResult) {
					case 0:
						img = ticketConfigData.waitImg;
						break;
					case 1:
						switch (this.payResult) {
							case 0:
								img = ticketConfigData.successImg;
								break;
							case 1:
								img = ticketConfigData.paySuccessImg;
								break;
							case 2:
								img = ticketConfigData.refundImg;
								break;
							default:
								img = ticketConfigData.successImg;
								break;
						}

						break;
					case 2:
						img = ticketConfigData.failImg;
						break;
					default:
						break;
				}

				return img;
			};
		},
		periodTypeFirst() {
			const firstDate = this.periodTypes?.[0] || -1;
			return firstDate;
		},
		momentFunc() {
			return date => moment(date);
		},
		noticeHtml() {
			return `
				<strong>Ⅰ.</strong>本活动门票采用抽选方式进行，阶段以及时间如下：
				<br />
				抽选时间     <font class="red-txt-bold">${moment(this.periodInfo.registerStartDate).format('YYYY年M月D日HH:mm')}</font>-<font class="red-txt-bold">${moment(this.periodInfo.registerEndDate).format('YYYY年M月D日HH:mm')}</font>
				<br />
				中选时间     <font class="red-txt-bold">${moment(this.periodInfo.ticketStartDate).format('YYYY年M月D日HH:mm')}</font>-<font class="red-txt-bold">${moment(this.periodInfo.ticketEndDate).format('YYYY年M月D日HH:mm')}</font>
				<br />
				<br />
				<strong>Ⅱ.</strong>根据现行法律及公安、防疫部门对大型活动实名制的要求，实名制的项目在登记时需提供你的实名信息，并在接收方采取严格信息保护措施的前提下向监管机关/主办机构/活动场馆/出票方/票务代理方提供你的实名信息，用于出票、入场核验身份或突发公共卫生/安全事件调查，实名信息包括姓名身份证(或港澳居民来往内地通行证/台湾居民来往大陆通行证等有效证照)。登记的实名信息，可与游戏账号绑定的身份信息不一致，但入场人脸验证时会以登记抽选时录入的实名信息为准，如<font class="red-txt-bold">信息不一致将无法入场，一旦登记将无法修改</font>。
				<br />
				<br />
				<strong>Ⅲ.</strong><font class="red-txt-bold">1月1日-6月18日期间</font>有登录游戏记录且最高战斗职业等级达到<font class="red-txt-bold">81级</font>的账号才可以参与抽选。
				<br />
				<br />
				<strong>Ⅳ.</strong>抽选时可以以单人或者双人组队的方式进行，若<font class="red-txt-bold">组队将同步中选或者不中选</font>，<font class="red-txt-bold">${moment(this.periodInfo.teamEndDate).format('M月D日HH:mm')}</font>前可以随时更换队伍状态以及信息。
				<br />
				<br />
				<strong>Ⅴ.</strong>本次活动一共举办2天，2天门票将作为2个商品单独进行，需单独进行抽选，可以同时选择2天门票进行抽选，抽选结果可能为<font class="red-txt-bold">不中选，中选1天，中选2天</font>。
				<br />
				<br />
				<strong>Ⅵ.</strong>我们会尽量以短信形式通知中选的玩家，但最终还是以活动页面订单为准，若抽中2天的玩家<font class="red-txt-bold">必须要确认2天</font>，不可单独确认某一天的订单，组队双方需各自确认各自的订单，队友不确认不影响已确认的门票资格。
				<br />
				<br />
				<strong>Ⅶ.</strong>截止每轮确认后<font class="red-txt-bold">中选未确认</font>的名额将会<font class="red-txt-bold">取消</font>相应确认资格，我们将会从剩余参与抽选但未中选的用户中继续补抽，确认资格完全结束后官网会另行通知。
				<br />
				<br />
				<strong>Ⅷ.</strong>本商品由于产品特殊性，在7月6日14:00前申请取消确认的需收取票价<font class="red-txt-bold">2%</font>的手续费。在7月6日14:00至7月26日24:00前申请取消确认，需收取票价<font class="red-txt-bold">30%</font>的取消费。7月27日后将不再接受取消申请。在活动开始前如因法律规定之“不可抗力因素”需要取消的，在出示相应凭证后不受上述限制，予以全额退回，取消确认需要通过<a href="https://kf.sdo.com/img/wechatinfo.jpg" target="_blank" rel="noopener noreferrer">联系客服</a>进行申请，仅接受整单取消。
				<br />
				<br />
				<strong>Ⅸ.</strong>如有其他问题可以通过客服反馈。
				<br />
				<br>
			`;
		},
	},
};
</script>

<style scoped lang='scss'>
	.page {
	}
	.app-pc {
		.page {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 30px;

			.page-bg {
				position: absolute;
				left: 0;
				top: 0;
				width: 100vw;
				z-index: -1;
			}

			.page-slogan {
				margin-top: 55px;
				max-width: 55%;
			}
			.login-info {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 40px;
				padding: 9px 30px;
				border-radius: 17.5px 17.5px 17.5px 17.5px;
				background: #decb8b;
				box-shadow: 0 0 5px 0 #0d4e2d;

				color: #210000;
				font-family: Microsoft YaHei;
				font-size: 16px;
				line-height: 16px;
				text-align: center;

				.logout-btn {
					color: #ff0000;
				}

				.tips-pop {
					display: none;
				}
			}

			.date-info-box {
				position: relative;
				.date-info {
					margin-top: 34px;
					border-radius: 10px 10px 10px 10px;
					width: 652px;
					max-width: 100%;
					overflow: hidden;
					border: 1px solid #389566;

					.date-info-node {
						display: flex;
						align-items: center;
						width: 100%;
						height: 45px;

						.info-label {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 118px;
							height: 100%;
							background-color: #4CAB7B;

							font-weight: 600;
							font-size: 22px;
							color: #FFF5D3;
							letter-spacing: 2px;
						}
						.info-content {
							display: flex;
							justify-content: center;
							align-items: center;
							flex-grow: 1;

							color: #31110f;
							font-family: FZZZHONGJW;
							font-weight: 600;
							font-size: 18px;
							letter-spacing: 2px;
						}
					}
					.date-info-node:first-child {
						border-bottom: 1px solid #389566;
					}
				}

				.tips-pop {
					position: absolute;
					top: calc(50% + 4.5px);
					left: calc(100% + 20px);
					display: flex;
					align-items: center;
					white-space: nowrap;

					font-size: 16px;
					color: #389566;

					.tips-pop-logo {
						margin-right: 7px;
						// width: 25px;
					}
				}
			}

			.ticket-info-box {
				position: relative;
				margin-top: 38px;

				.ticket-info-bg {}

				.ticket-info-btn {
					position: absolute;
					left: calc(50% - 106px);
					bottom: 110px;
					width: 212px;
				}
			}

			.ticket-info-bg-mobile {
				display: none;
			}
			.ticket-info-bg-h5 {
				display: none;
			}
			.ticket-info-bg-tm {
				margin-top: 150px;
			}

			.ticket-box {
				position: relative;
				margin-top: 38px;

				.dialog-content-box {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding: 16px;
					box-sizing: border-box;
					width: 1000px;
					// height: 704px;
					border-radius: 20px 20px 20px 20px;
					border: 3px solid #210000;
					background: #4CAB7B;

					.dialog-content {
						margin-top: 16px;
						width: 100%;
						height: 100%;
						border-radius: 10px 10px 10px 10px;
						border: 3px solid #210000;
						background: #fff5d3;

						.back-box {
							display: flex;
							justify-content: flex-end;
							align-items: center;
							margin-top: 23px;
							padding-right: 33px;
							box-sizing: border-box;

							font-weight: 600;
							font-size: 18px;
							color: #4CAB7B;
							letter-spacing: 2px;

							img {
								margin-right: 11px;
							}
						}

						.dialog-title {
							margin-top: -23px;
							font-family: FZZDHJW;
							font-weight: bold;
							font-size: 34px;
							text-align: center;
							color: #389566;
							letter-spacing: 3px;
						}

						.dialog-title-top {
							margin-top: 40px;
						}

						.dialog-txt {
							// max-height: calc(100% - 80px);
							// overflow-y: auto;
							padding: 30px;
							box-sizing: border-box;

							color: #6b5a47;
							font-family: Microsoft YaHei;
							font-size: 16px;
							line-height: 24px;
							letter-spacing: 3px;
						}

						.ticket-list {
							display: flex;
							justify-content: center;

							.ticket-node {
								margin: 0 12px;
							}
						}

						.dialog-tips {
							margin-top: 26px;
							color: #8f7d40;
							font-family: Microsoft YaHei;
							font-size: 16px;
							text-align: center;
							line-height: 24px;
							letter-spacing: 3px;
						}
						.dialog-tips-top {
							margin-top: 0;
						}

						.form-box {
							margin: 0 auto;
							margin-top: 38px;
							width: 505px;

							.form-node {
								position: relative;
								display: flex;
								margin-bottom: 35px;

								.form-label {
									display: flex;
									justify-content: center;
									align-items: center;
									margin-right: 10px;
									width: 130px;
									height: 40PX;
									border-radius: 5px 5px 5px 5px;
									background: #4cab7b;

									color: #fff5d3;
									font-family: JCuYuan;
									font-size: 18px;
									letter-spacing: 2px;
								}
								.form-action {
									flex: 1;
								}
								.form-tips {
									position: absolute;
									right: 0;
									bottom: -25px;

									font-size: 16px;
									line-height: 16px;
									color: #8F7D40;
									letter-spacing: 1px;
								}
							}
						}

						.form-confirm-box {
							padding: 0 70px;
							box-sizing: border-box;

							.form-confirm-node {
								display: flex;
								margin-top: 35px;
								width:  100%;

								.form-confirm-node-left {
									display: flex;
									width: 50%;
								}
								.form-confirm-node-right {
									display: flex;
									width: 50%;
								}

								.form-label {
									display: flex;
									justify-content: center;
									align-items: center;
									margin-right: 10px;
									width: 130px;
									height: 40px;
									border-radius: 5px 5px 5px 5px;
									background: #4cab7b;

									color: #fff5d3;
									font-family: JCuYuan;
									font-size: 18px;
									letter-spacing: 2px;
								}
								.form-value {
									// display: flex;
									// align-items: center;
									flex: 1;
									font-size: 16px;
									line-height: 40px;
									text-align: left;
									color: #31110F;
									letter-spacing: 0;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}
						}

						.info-confirm-box {
							position: relative;
							margin: 0 60px;
							margin-top: 40px;
							padding: 40px 0;
							border: 1px solid #389566;

							.info-confirm-title {
								position: absolute;
								top: -14px;
								left: calc(50% - 100px);
								background: #FFF5D3;
								width: 200px;
								font-weight: 600;
								font-size: 28px;
								line-height: 28px;
								text-align: center;
								color: #389566;
								letter-spacing: 3px;
							}
							.info-confirm-title-slogan {
								position: absolute;
								top: 24px;
								left: calc(50% - 100px);
								width: 200px;
								font-weight: 300;
								font-size: 14px;
								text-align: center;
								color: #389566;
								letter-spacing: 3px;
							}

							.session-info-box {
								.session-info-node {
									display: flex;
									flex-direction: column;
									align-items: center;
									margin-top: 38px;
									width: 100%;

									.info-label {
										display: flex;
										justify-content: center;
										align-items: center;
										width: 250px;
										height: 40px;
										border-radius: 5px 5px 5px 5px;
										background: #4cab7b;

										font-size: 18px;
										line-height: 18px;
										color: #FFF5D3;
									}
									.info-content {
										margin-top: 10px;
										font-size: 18px;
										color: #31110F;
										letter-spacing: 0;
									}
									.info-content-blue {
										display: flex;
										align-items: center;
										padding: 5px 10px;
										color: #fff;
										background: #3D6991;
										border-radius: 5px 5px 5px 5px;
									}
									.info-content-red {
										display: flex;
										align-items: center;
										padding: 5px 10px;
										color: #fff;
										background: #B53934;
										border-radius: 5px 5px 5px 5px;
									}
								}
							}
						}

						.btn-group-box {
							display: flex;
							justify-content: center;
							margin-bottom: 40px;

							.btn-node {
								margin-left: 28px;
							}
							.btn-node:first-child {
								margin-left: 0;
							}
						}
					}
					.dialog-content:first-child {
						margin-top: 0;
					}
					.result-box {
						.dialog-title {
							margin-top: 40px;
						}
						.info-confirm-box {
							margin-top: 0;
							border: none;

							.info-confirm-title {
								top: 0;
							}

							.ticket-list {
								margin-top: 23px;
							}
						}
					}
				}

				.access-checked-box {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 30px 0;

					font-size: 16px;
					line-height: 16px;
					color: #8F7D40;
					letter-spacing: 1px;

					/deep/.van-checkbox {
						margin-right: 7px;

						.van-checkbox__icon--checked {
							.van-icon {
								background-color: #fff;
								border-color: #4CAB7B;
								user-select: none;
								-ms-user-select: none;
								-webkit-user-select: none;
							}
							.van-icon:before {
								color: #4CAB7B;
							}
						}
					}
				}
			}

			.next-btn {
				margin: 0 auto;
				margin-bottom: 40px;
			}

			.invite-info-box {
				display: flex;
				flex-direction: column;
				align-items: center;
				overflow-x: hidden;

				.invite-code {
					font-weight: 600;
					font-size: 30px;
					line-height: 30px;
					color: #6B5A47;
				}
				.copy-btn {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 19px 0 60px;
					width: 97px;
					height: 35px;
					border-radius: 18px 18px 18px 18px;
					background: #decb8b;
					box-shadow: 0 0 5px 0 #0d4e2d;

					font-size: 16px;
					line-height: 16px;
					color: #6B5A47;
				}
				.invite-tips {
					margin-bottom: 60px;
					text-align: center;
				}
			}

			.team-info-box {
				display: flex;
				flex-direction: column;
				align-items: center;

				.info-title {
					margin-bottom: 15px;
					max-width: 100%;
					text-align: center;
				}
				.form-action {
				}
				.submit-btn {
					margin: 30px 0 40px;
				}

				.invite-team-info {
					.ticket-date-box {
						display: flex;
						flex-direction: column;
						align-items: center;
						margin-top: 30px;
					}
				}
			}

			.margin-border {
				margin: 30px 0;
			}
		}
	}
	.app-mobile {
		.page {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;
			padding-bottom: 10px;

			.page-bg {
				display: none;
			}

			.page-slogan {
				margin-top: 9px;
				max-width: 79%;
			}
			.login-info {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 15px;
				padding: 5px 15px;
				border-radius: 10px 10px 10px 10px;
				background: #decb8b;
				box-shadow: 0 0 2.5px 0 #0d4e2d;

				color: #210000;
				font-family: Microsoft YaHei;
				font-size: 10px;
				line-height: 10px;
				text-align: center;

				.logout-btn {
					color: #ff0000;
				}

				.tips-pop {
					position: absolute;
					right: -30px;
				}
				.tips-pop {
					position: absolute;
					right: -65px;
					display: flex;
					align-items: center;
					white-space: nowrap;

					font-size: 10px;
					color: #389566;

					.tips-pop-logo {
						margin-right: 3px;
						width: 12.5px;
					}
				}
			}

			.date-info-box {
				position: relative;
				width: 100%;
				.date-info {
					margin-top: 18px;
					border-radius: 5px 5px 5px 5px;
					overflow: hidden;
					width: 100%;
					border: 1px solid #389566;

					.date-info-node {
						display: flex;
						align-items: center;
						width: 100%;
						height: 22px;

						.info-label {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 64px;
							height: 100%;
							background-color: #4CAB7B;

							font-weight: 600;
							font-size: 11px;
							color: #FFF5D3;
							letter-spacing: 2px;
						}
						.info-content {
							display: flex;
							justify-content: center;
							align-items: center;
							flex-grow: 1;

							color: #31110f;
							font-family: FZZZHONGJW;
							font-weight: 600;
							font-size: 10px;
							letter-spacing: 1px;
						}
					}
					.date-info-node:first-child {
						border-bottom: 1px solid #389566;
					}
				}

				.tips-pop {
					display: none;
				}
			}

			.ticket-info-box {
				position: relative;
				margin-top: 18px;
				width: 100%;

				.ticket-info-bg {
					display: none;
				}

				.ticket-info-btn {
					position: absolute;
					left: calc(50% - 51px);
					bottom: 32.5%;
					width: 102px;
					z-index: 1001;
				}
			}

			.ticket-info-bg-mobile {
				position: fixed;
				left: 0;
				bottom: 0;
				width: 100vw;
			}
			.ticket-info-bg-h5 {
				width: 100%;
				z-index: 1000;
			}

			.ticket-info-bg-tm {
				margin-top: 18px;
				width: 150px;
			}

			.ticket-box {
				position: relative;
				margin-top: 18px;
				max-width: 100%;

				.dialog-content-box {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding: 5px;
					box-sizing: border-box;
					// width: 1000px;
					// height: 704px;
					border-radius: 10px 10px 10px 10px;
					border: 3px solid #210000;
					background: #4CAB7B;

					.dialog-content {
						margin-top: 16px;
						width: 100%;
						height: 100%;
						border-radius: 7.5px 7.5px 7.5px 7.5px;
						border: 3px solid #210000;
						background: #fff5d3;

						.back-box {
							display: flex;
							justify-content: flex-end;
							align-items: center;
							margin-top: 9px;
							padding-right: 9px;
							box-sizing: border-box;

							font-weight: 600;
							font-size: 10px;
							color: #4CAB7B;
							letter-spacing: 1px;

							img {
								width: 18px;
								margin-right: 5px;
							}
						}

						.dialog-title {
							font-family: FZZDHJW;
							font-weight: bold;
							font-size: 17px;
							text-align: center;
							color: #389566;
							letter-spacing: 3px;
						}

						.dialog-title-top {
							margin-top: 40px;
						}

						.dialog-txt {
							// max-height: calc(100% - 80px);
							// overflow-y: auto;
							padding: 22px;
							box-sizing: border-box;

							color: #6b5a47;
							font-family: Microsoft YaHei;
							font-size: 10px;
							line-height: 14px;
							letter-spacing: 1px;
						}

						.ticket-list {
							display: flex;
							justify-content: center;

							.ticket-node {
								margin: 0 4px;

								img {
									width: 144px;
								}
							}
						}

						.dialog-tips {
							// margin-top: 18px;
							padding: 0 5px;
							box-sizing: border-box;
							color: #8f7d40;
							font-family: Microsoft YaHei;
							font-size: 10px;
							text-align: center;
							line-height: 14px;
							letter-spacing: 2px;
						}
						.dialog-tips-top {
							margin-top: 0;
						}

						.form-box {
							margin: 0 auto;
							margin-top: 18px;
							// width: calc(100% - 70px);

							.form-node {
								position: relative;
								display: flex;
								margin-bottom: 18px;

								.form-label {
									display: flex;
									justify-content: center;
									align-items: center;
									margin-right: 10px;
									width: 65px;
									height: 30px;
									border-radius: 2.5px 2.5px 2.5px 2.5px;
									background: #4cab7b;

									color: #fff5d3;
									font-family: JCuYuan;
									font-size: 11px;
								}
								.form-action {
									flex: 1;
									/deep/.el-input__inner {
										height: 30px;
									}
									/deep/.el-input__icon {
										line-height: 30px;
									}
								}
								.form-tips {
									position: absolute;
									right: 0;
									bottom: -15px;

									font-size: 10px;
									line-height: 10px;
									color: #8F7D40;
									letter-spacing: 1px;
								}
							}
						}

						.form-confirm-box {
							padding: 0 10px;
							box-sizing: border-box;

							.form-confirm-node {
								display: flex;
								flex-direction: column;
								margin-top: 18px;
								padding-left: 30px;
								width:  100%;

								.form-confirm-node-left {
									display: flex;
									margin-bottom: 18px;
								}
								.form-confirm-node-right {
									display: flex;
								}

								.form-label {
									display: flex;
									justify-content: center;
									align-items: center;
									margin-right: 10px;
									width: 65px;
									height: 30px;
									border-radius: 2.5px 2.5px 2.5px 2.5px;
									background: #4cab7b;

									color: #fff5d3;
									font-family: JCuYuan;
									font-size: 11px;
								}
								.form-value {
									// display: flex;
									// align-items: center;
									flex: 1;
									font-size: 10px;
									line-height: 30px;
									text-align: left;
									color: #31110F;
									letter-spacing: 0;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}
						}

						.info-confirm-box {
							position: relative;
							margin-top: 15px;
							padding: 40px 0 25px;
							border: 1px solid #389566;

							.info-confirm-title {
								position: absolute;
								top: -7px;
								left: calc(50% - 50px);
								background: #FFF5D3;
								width: 100px;
								font-weight: 600;
								font-size: 14px;
								line-height: 14px;
								text-align: center;
								color: #389566;
								letter-spacing: 1.5px;
							}
							.info-confirm-title-slogan {
								position: absolute;
								top: 12px;
								left: calc(50% - 50px);
								width: 100px;
								font-weight: 300;
								font-size: 8px;
								text-align: center;
								color: #389566;
								letter-spacing: 1.5px;
							}

							.session-info-box {
								.session-info-node {
									display: flex;
									flex-direction: column;
									align-items: center;
									margin-top: 19px;
									width: 100%;

									.info-label {
										display: flex;
										justify-content: center;
										align-items: center;
										width: 150px;
										height: 30px;
										border-radius: 2.5px 2.5px 2.5px 2.5px;
										background: #4cab7b;

										font-size: 11px;
										line-height: 11px;
										color: #FFF5D3;
									}
									.info-content {
										margin-top: 10px;
										font-size: 10px;
										color: #31110F;
										letter-spacing: 0;
									}
									.info-content-blue {
										display: flex;
										align-items: center;
										padding: 3px 6px;
										color: #fff;
										background: #3D6991;
										border-radius: 2.5px 2.5px 2.5px 2.5px;
									}
									.info-content-red {
										display: flex;
										align-items: center;
										padding: 3px 6px;
										color: #fff;
										color: #fff;
										background: #B53934;
										border-radius: 2.5px 2.5px 2.5px 2.5px;
									}
								}
							}
						}

						.btn-group-box {
							display: flex;
							flex-direction: column;
							align-items: center;
							margin-bottom: 30px;

							.btn-node {
								margin-bottom: 18px;
							}
							.btn-node:first-child {
								margin-left: 0;
							}
						}
					}
					.dialog-content:first-child {
						margin-top: 0;
					}
					.result-box {
						.info-confirm-box {
							margin-top: 0;
							border: none;

							.info-confirm-title {
								top: 0;
							}

							.ticket-list {
								margin-top: 18px;
							}
						}
					}
				}

				.access-checked-box {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 30px 0;

					font-size: 12px;
					line-height: 12px;
					color: #8F7D40;
					letter-spacing: 1px;

					/deep/.van-checkbox {
						margin-right: 7px;

						.van-checkbox__icon--checked {
							.van-icon {
								background-color: #fff;
								border-color: #4CAB7B;
							}
							.van-icon:before {
								color: #4CAB7B;
							}
						}
					}
				}
			}

			.next-btn {
				margin: 0 auto;
				margin-bottom: 40px;
			}

			.invite-info-box {
				display: flex;
				flex-direction: column;
				align-items: center;

				.invite-code {
					font-weight: 600;
					font-size: 16px;
					line-height: 16px;
					color: #6B5A47;
				}
				.copy-btn {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 16px 0 30px;
					width: 49px;
					height: 21px;
					border-radius: 10px 10px 10px 10px;
					background: #decb8b;
					box-shadow: 0 0 2.5px 0 #0d4e2d;

					font-size: 10px;
					line-height: 10px;
					color: #6B5A47;
				}
				.invite-tips {
					font-size: 11px;
					line-height: 16px;
					margin-bottom: 30px;
					text-align: center;
				}
			}

			.team-info-box {
				display: flex;
				flex-direction: column;
				align-items: center;

				.info-title {
					margin-bottom: 15px;
					max-width: 100%;
					text-align: center;
				}
				.form-action {
					/deep/.el-input__inner {
						height: 30px;
					}
				}
				.submit-btn {
					margin: 20px 0 20px;
				}

				.invite-team-info {
					.ticket-date-box {
						display: flex;
						flex-direction: column;
						align-items: center;
						margin-top: 30px;
					}
				}
			}

			.margin-border {
				margin: 9px 0;
			}
		}
	}
</style>

<style lang='scss'>
	body {
		background: #FFF5D3;

		.hover-dom {
			cursor: pointer;
		}

		.hover-dom:hover {
			opacity: .9;
		}
	}
	.app-pc-client-1 {
		font-size: 37.5Px !important;
	}
	.app-pc-client-2 {
		font-size: 37.5Px !important;
	}
	.app-pc-client-3 {
		font-size: 37.5Px !important;
	}
	.app-mobile-client-1 {
	}
	.app-mobile-client-2 {
		font-size: 43Px !important;
	}
	.app-mobile-client-3 {
		font-size: 50Px !important;
	}
</style>
